import noodleApiClient from '@/tsClient/servers/noodleApi';

const getConversationSidByProductId = async (id: string): Promise<string> => {
  const data = await noodleApiClient.get(`/products/${id}/conversationSid`);
  return data.data;
};

export default getConversationSidByProductId;
